<template lang="pug">
  b-modal#addMatchByBatch(
  ref="addMatchByBatch"
  :title="$t('ui.combine.add_match_by_batch')"
  centered
  no-fade
  size="lg"
  :busy="loading"
  @ok="done"
  @shown="reset")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      div.mb-3
        div.form-row
          div.col-md-4.mb-1
            b-input-group(size="sm")
              b-input-group-text(slot="prepend")
                span {{ $t("ui.criteria") }}
              DebounceInput(required type="text" v-model="searchCriteria" :placeholder="$t('message.search_by_league_name')")
          div.col-md-2.mb-1
            SubmitButton(
              :loading="loading"
              icon="fa fa-search"
              :text="$t('ui.search')"
              type="button"
              @click="getMatchList()"
              variant="success"
              size="sm"
              ).mr-2
      div
        div.row.mb-3.animated.fadeIn
          div.col.clusterize
            div.clusterize-scroll(style="max-height: 500px;")
              table.tablex(style="width: 100%;")
                thead
                  tr
                    th.sticky-position(width=80)
                      span {{ $t('ui.id') }}
                    th.sticky-position(width=80)
                      span {{ $tc('ui.sports', 1) }}
                    th.sticky-position
                      span {{ $tc("ui.leagues", 1) }}
                    th.sticky-position
                      span {{ $t("ui.home") }}
                    th.sticky-position
                      span {{ $t("ui.away") }}
                    th.sticky-position(width=60)
                      span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                    th.sticky-position(width=80)
                      span {{ $t("ui.short.match_date") }}
                    th.sticky-position(width=80)
                      span {{ $t("ui.short.match_time") }}
                tbody.clusterize-content
                  tr(v-if="matchList.length == 0")
                    td(colspan="8").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in matchList")
                    td
                      span {{ item.match_id }}
                    td
                      span {{ item.sport_type }}
                    td
                      span(:title="item.league_name") {{ item.league_name }}
                    td
                      span(:title="item.home_team") {{ item.home_team }}
                    td
                      span(:title="item.away_team") {{ item.away_team }}
                    td.text-uppercase
                      span {{ item.market_type }}
                    td
                      span {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                    td
                      span {{ item.match_time }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      matchList: [],
      searchCriteria: "",
      provider: ""
    };
  },
  computed : {
  },
  methods: {
    reset() {
      this.searchCriteria = "";
      this.matchList = [];
    },
    done: function(evt) {
      evt.preventDefault();
      if (this.matchList.length > 0) {
        this.submit();
      } else {
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.matchListIsEmpty"), "error");
      }

    },
    submit: function() {
      let url = config.addMatchByBatchUrl();

      var list = [];
      for(var i = 0; i < this.matchList.length; i++) {
        list.push(this.matchList[i].match_id);
      }

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.mapmatchothers,
        match_id_str: list.join(', '),
        provider_id: this.provider
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.addMatchByBatch.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_match_by_batch", this.feedback.status);
                this.$refs.addMatchByBatch.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getMatchList: function() {
      let url = config.getAddMatchByBatchListUrl();

      var arr = this.searchCriteria.split(";");

      if (arr.length == 5) {
        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.mapmatchothers,
          sport_id: arr[1],
          league_id: arr[2],
          match_date: arr[3],
          provider_id: arr[4]
        };

        this.provider = arr[4];

        this.$http.post(url, json).then(
          function(response) {
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.matchList = response.data.tbl_add_match_by_batch_list;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.invalidSearchCriteriaFormat"), "error");
      }
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
